import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, message, Modal, Row, Space, Upload } from "antd";
import React, { useEffect, useState } from "react";

import logoEntete from "./Image/logo_entete_default.png";
import signature from "./Image/signature_default.jpg";
import logoIPM from "./Image/logo_ipm_default.png";
import { ParticipantsIpmService } from "../Services/ParticipantsIpmService";
import api from "../Services/AxiosInstance";

const EnteteSignature = () => {
  const defaultLogoEntete = logoEntete;
  const defaultSignature = signature;
  const defaultLogoIPM = logoIPM;
  //InfosGen/getEntete/logo
  const [fileList, setFileList] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleSignature, setModalVisibleSignature] = useState(false);
  const [modalVisibleLogoIPM, setModalVisibleLogoIPM] = useState(false);
  const [imgLogoEntete, setImgLogoEntete] = useState();
  const [imgLogoIPM, setImgLogoIPM] = useState();
  const [imgSignature, setImgSignature] = useState();

  const enteteSignatureService = new ParticipantsIpmService();



  const openModalSignature = () => {
    setModalVisibleSignature(true);
  };

  const closeModalSignature = () => {
    setModalVisibleSignature(false);
    setFileList([]);
  };

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setFileList([]);
  };

  const openModalLogoIPM = () => {
    setModalVisibleLogoIPM(true);
  };

  const closeModalLogoIPM = () => {
    setModalVisibleLogoIPM(false);
    setFileList([]);
  };

  const fetchImgLogoEntete = async () => {
    try {
      const image = await enteteSignatureService.fetchImageIPM('logo_ipm');
      if (image) {
        setImgLogoEntete(image);
      } else {
        console.error("Image non trouvée ");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  const fetchImgLogoIPM = async () => {
    try {
      const image = await enteteSignatureService.fetchImageIPM('logo_accueil');
      if (image) {
        setImgLogoIPM(image);
      } else {
        console.error("Image non trouvée ");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  const fetchImgSignature = async () => {
    try {
      const image = await enteteSignatureService.fetchImageIPM('signature');
      if (image) {
        setImgSignature(image);
      } else {
        console.error("Image non trouvée ");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  //InfosGen/addEntete/logo
  //InfosGen/addEntete/signature
  const handleUploadChange = ({ fileList }) => {
    setFileList(fileList.slice(-1));
  };

  const handleUploadlogo = async () => {
    if (fileList.length === 0) {
      message.error("Veuillez sélectionner une image.");
      return;
    }

    const formData = new FormData();
    formData.append("file", fileList[0].originFileObj);

    try {
      await api.post(`InfosGen/addEntete/logo_ipm`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }); // Appel à l'API pour télécharger l'image
      message.success("Photo mise à jour avec succès!");
      setModalVisible(false);
      setFileList([]);
      fetchImgLogoEntete(); // Recharger l'image après le téléchargement
    } catch (error) {
      message.error("Erreur lors du téléchargement de la photo.");
    }
  };

  const handleUploadSignature = async () => {
    if (fileList.length === 0) {
      message.error("Veuillez sélectionner une image.");
      return;
    }

    const formData = new FormData();
    formData.append("file", fileList[0].originFileObj);

    try {
      await api.post(`/InfosGen/addEntete/signature`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }); // Appel à l'API pour télécharger l'image
      message.success("Photo mise à jour avec succès!");
      setModalVisibleSignature(false);
      setFileList([]);
      fetchImgSignature(); // Recharger l'image après le téléchargement
    } catch (error) {
      message.error("Erreur lors du téléchargement de la photo.");
    }
  };

  const handleUploadLogoIPM = async () => {
    if (fileList.length === 0) {
      message.error("Veuillez sélectionner une image.");
      return;
    }

    const formData = new FormData();
    formData.append("file", fileList[0].originFileObj);

    try {
      await api.post(`InfosGen/addEntete/logo_accueil`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      message.success("Logo IPM mis à jour avec succès!");
      setModalVisibleLogoIPM(false);
      setFileList([]);
      fetchImgLogoIPM();
    } catch (error) {
      message.error("Erreur lors du téléchargement du logo.");
    }
  };

  useEffect(() => {
    fetchImgLogoIPM();
    fetchImgLogoEntete();
    fetchImgSignature();
  }, []);

  return (
    <div>
      <Row gutter={16}>
        <Col span={8}>
          <Card
            title="Entête"
            hoverable
            style={{ width: "100%", textAlign: "left", padding: 12 }}
            cover={
              <Space
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <img
                  src={imgLogoEntete || defaultLogoEntete}
                  alt="avatar"
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "contain",
                    borderRadius: "8px 8px 8px 8px",
                  }}
                />
              </Space>
            }
          >
            <Card.Meta
              style={{ marginTop: 0 }}
              description={
                <Button
                  type="primary"
                  icon={<EditOutlined />}
                  onClick={openModal}
                >
                  Changer Entête
                </Button>
              }
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card
            title="Signature"
            hoverable
            style={{ width: "100%", textAlign: "left", padding: 12 }}
            cover={
              <Space
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <img
                  src={imgSignature || defaultSignature}
                  alt="avatar"
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "contain",
                    borderRadius: "8px 8px 8px 8px",
                  }}
                />
              </Space>
            }
          >
            <Card.Meta
              style={{ marginTop: 0 }}
              description={
                <Button
                  type="primary"
                  icon={<EditOutlined />}
                  onClick={openModalSignature}
                >
                  Changer la signature
                </Button>
              }
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card
            title="Logo IPM"
            hoverable
            style={{ width: "100%", textAlign: "left", padding: 12 }}
            cover={
              <Space
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <img
                  src={imgLogoIPM || defaultLogoIPM}
                  alt="logo ipm"
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "contain",
                    borderRadius: "8px 8px 8px 8px",
                  }}
                />
              </Space>
            }
          >
            <Card.Meta
              style={{ marginTop: 0 }}
              description={
                <Button
                  type="primary"
                  icon={<EditOutlined />}
                  onClick={openModalLogoIPM}
                >
                  Changer Logo IPM
                </Button>
              }
            />
          </Card>
        </Col>
      </Row>

      <Modal
        title="Changer Entête"
        open={modalVisible}
        onCancel={closeModal}
        footer={[
          <Button key="cancel" onClick={closeModal}>
            Annuler
          </Button>,
          <Button key="submit" type="primary" onClick={handleUploadlogo}>
            Enregistrer
          </Button>,
        ]}
      >
        <Card
          hoverable
          style={{ width: 240, margin: "0 auto", textAlign: "center" }}
          cover={
            <Upload
              beforeUpload={() => false}
              fileList={fileList}
              onChange={handleUploadChange}
              accept="image/*"
              showUploadList={false}
              maxCount={1}
            >
              <div
                style={{
                  padding: "20px",
                  border: "1px dashed #d9d9d9",
                  borderRadius: "4px",
                }}
              >
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>
                  Sélectionner une image en png
                </div>
              </div>
            </Upload>
          }
        >
          {fileList.length > 0 && (
            <img
              alt="example"
              style={{ width: "100%", marginTop: "16px" }}
              src={URL.createObjectURL(fileList[0].originFileObj)}
            />
          )}
        </Card>
      </Modal>
      <Modal
        title="Changer la signature"
        open={modalVisibleSignature}
        onCancel={closeModalSignature}
        footer={[
          <Button key="cancel" onClick={closeModalSignature}>
            Annuler
          </Button>,
          <Button key="submit" type="primary" onClick={handleUploadSignature}>
            Enregistrer
          </Button>,
        ]}
      >
        <Card
          hoverable
          style={{ width: 240, margin: "0 auto", textAlign: "center" }}
          cover={
            <Upload
              beforeUpload={() => false}
              fileList={fileList}
              onChange={handleUploadChange}
              accept="image/*"
              showUploadList={false}
              maxCount={1}
            >
              <div
                style={{
                  padding: "20px",
                  border: "1px dashed #d9d9d9",
                  borderRadius: "4px",
                }}
              >
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>
                  Sélectionner une image en jpg
                </div>
              </div>
            </Upload>
          }
        >
          {fileList.length > 0 && (
            <img
              alt="example"
              style={{ width: "100%", marginTop: "16px" }}
              src={URL.createObjectURL(fileList[0].originFileObj)}
            />
          )}
        </Card>
      </Modal>
      <Modal
        title="Changer Logo IPM"
        open={modalVisibleLogoIPM}
        onCancel={closeModalLogoIPM}
        footer={[
          <Button key="cancel" onClick={closeModalLogoIPM}>
            Annuler
          </Button>,
          <Button key="submit" type="primary" onClick={handleUploadLogoIPM}>
            Enregistrer
          </Button>,
        ]}
      >
        <Card
          hoverable
          style={{ width: 240, margin: "0 auto", textAlign: "center" }}
          cover={
            <Upload
              beforeUpload={() => false}
              fileList={fileList}
              onChange={handleUploadChange}
              accept="image/*"
              showUploadList={false}
              maxCount={1}
            >
              <div
                style={{
                  padding: "20px",
                  border: "1px dashed #d9d9d9",
                  borderRadius: "4px",
                }}
              >
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>
                  Sélectionner une image
                </div>
              </div>
            </Upload>
          }
        >
          {fileList.length > 0 && (
            <img
              alt="example"
              style={{ width: "100%", marginTop: "16px" }}
              src={URL.createObjectURL(fileList[0].originFileObj)}
            />
          )}
        </Card>
      </Modal>
    </div>
  );
};

export default EnteteSignature;
